<template>
 <div>
     <div class="row justify-content-center ">
         <div class="col-md-8 pt-3">
             <p class="font-weight-bold pl-3 mb-4 sb-block-title">My Immunizations</p>
         </div>
         <div class="col-md-4 pt-3 text-right pr-4">
             <a href="/my-health/immunizations/edit" aria-label="My Immunizations - Edit" class="color-sky-blue-3" v-if="ims.length > 0">
                 Edit
             </a>
         </div>
     </div>
     <div class="row justify-content-center ">
         <div class="col-md-12">
             <div class="col-md-12 mb-2">
                 <a href="/my-health/immunizations/add" class="btn btn-primary btn-sb">Add new immunization</a>
             </div>
             <ul class="list-group mb-3" v-if="ims.length>0">
                 <li class="list-group-item border-top-0 border-right-0 border-left-0 border-bottom-0 ml-0 mr-0" v-for="(i, key) in ims" v-if="view_more || key < 4">
                     <div class="row border-bottom">
                         <div class="col-md-9 sb-list-fitem-regular">
                             {{ i.imm_sr ? i.imm_srname : i.immunization_data.imd_name }}
                         </div>
                         <div class="col-md-3 text-right sb-list-sitem">
                             <a href="#" class="text-danger" @click="deleteImById(i)" :aria-label="((i.imm_sr ? i.imm_srname : i.immunization_data.imd_name) + ' - Remove')">
                                 Remove
                             </a>
                         </div>
                     </div>
                     <ul class="list-group">
                         <li class="list-group-item border-top-0 border-left-0 border-right-0 pt-1 pb-1 sb-list-thitem-regular">
                             {{ outputDate(i) }}
                         </li>
                     </ul>
                 </li>
             </ul>
             <div v-if="ims.length>4" class="text-right mb-3 mr-3">
                 <a href="#" @click.prevent="view_more=!view_more" v-if="view_more" aria-label="View Less Immunizations">View Less</a>
                 <a href="#" @click.prevent="view_more=!view_more" v-else aria-label="View More Immunizations">View More</a>
             </div>
         </div>
     </div>
 </div>
</template>
<style>
    .mx-datepicker-popup{
        z-index: 10000;
    }
    .mx-datepicker{
        width: 100%;
    }
</style>

<script>
export default {
    props:['immunizations'],
    mounted() {
        this.listIm(true);
    },
    data() {
        return {
            route: '/api/immunizations',
            ims: [],
            view_more: false
        }
    },
    methods: {
        outputDate(i) {
            return moment(i.created_at).utc().format('MMMM DD, YYYY')
        },
        listIm(fromProp = false) {
            if (fromProp) {
                this.ims = this.immunizations;
            } else {
                this.$http.get(this.route)
                    .then(function (response) {
                        this.ims = response.data;
                    }, (response) => {
                        this._handleErrors(response.data, '#im-form')
                    })
            }
        },
        deleteImById(im) {
            if (!confirm('Do you really want to delete this immunization?'))
                return

            this.$http.delete(this.route + '/' + im.imm_id)
                .then(function (response) {
                    this.listIm();
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Immunization was deleted!'
                    });
                }, (response) => {
                    this._handleErrors(response.data, '#im-form')
                })
        },
        _handleErrors: function (items, selector) {
            $('.has-error').removeClass('has-error')
            $('.help-block').remove()

            for (var error in items['errors']) {
                if (items['errors'].hasOwnProperty(error)) {
                    var text = error;
                    var parts = text.split('.');
                    var name = parts.pop();
                    var el = $(selector + ' [name="' + name + '"]')
                    el.closest('.form-group').addClass('has-error')
                    $('<p class="help-block">' + (items['errors'][error].join(', ')) + '</p>').insertAfter(selector + ' [name="' + name + '"]');
                }
            }
        }
    }

}
</script>
